import i18n from '@opsbase/lib-i18n';
import usePositionFindById from '@opsbase/react-gql-hooks/position/usePositionFindById';
import usePositionUpdate from '@opsbase/react-gql-hooks/position/usePositionUpdate';
import TeamChooser from '@opsbase/web-data-choosers/TeamChooser';
import Dialog from '@opsbase/web-dialogs/Dialog';
import useParams from '@opsbase/web-nav/useParams';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function PositionEditDialog() {
    const { id } = useParams();
    const { loading, data } = usePositionFindById({ variables: { id } });
    const updatePosition = usePositionUpdate();
    const doUpsertPosition = useCallback(async (patch) => {
        await updatePosition({
            id: data.id,
            patch,
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updatePosition: {
                    __typename: 'Position',
                    ...data,
                    patch,
                },
            },
        });
    }, [data, updatePosition]);
    const handleChangeTitle = useCallback(async (title) => {
        if (!title)
            return;
        await doUpsertPosition({ title });
    }, [doUpsertPosition]);
    const handleChangeTeam = useCallback(async (team) => {
        if (team === null || team === void 0 ? void 0 : team.length) {
            await doUpsertPosition({ team: { id: team[0].id } });
        }
    }, [doUpsertPosition]);
    return (React.createElement(Dialog, { editableTitle: true, title: data ? data.title : i18n.t('loading'), onChangeTitle: handleChangeTitle, loading: loading || !data }, data && (React.createElement(React.Fragment, null,
        React.createElement(Text, null, i18n.t('which-team-this-position-for')),
        React.createElement(TeamChooser, { alwaysWrap: true, required: true, value: [data.team], onChange: handleChangeTeam, canCreate: true })))));
}
export default PositionEditDialog;
